<template>
    <div class="columns">
        <div class="column is-6">
            <div class="notification rounded">
                <div class="has-text-weight-semibold">Name</div>
                <span v-if="!noData">
                    <div>{{ sound.name }}</div>
                </span>
                <span v-else>
                    loading <span><i class="fas fa-sync fa-spin"></i></span>
                </span>
            </div>

            <div class="notification rounded" v-if="isAdmin">
                <div class="has-text-weight-semibold">Bucket</div>
                <span v-if="!noData">
                    <div>{{sound.bucket}}</div>
                </span>
                <span v-else>
                    loading <span><i class="fas fa-sync fa-spin"></i></span>
                </span>
            </div>

            <div class="notification rounded">
                <div class="has-text-weight-semibold">File Name</div>
                <span v-if="!noData">
                    <div>{{ sound.file_name }}</div>
                </span>
                <span v-else>
                    loading <span><i class="fas fa-sync fa-spin"></i></span>
                </span>
            </div>
        </div>

        <div class="column is-6">
            <div class="notification rounded">
                <div class="has-text-weight-semibold">Device</div>
                <span v-if="!noData">
                    <div>{{sound.device}}</div>
                </span>
                <span v-else>
                    loading <span><i class="fas fa-sync fa-spin"></i></span>
                </span>
            </div>

            <div class="notification rounded"  v-if="isAdmin">
                <div class="has-text-weight-semibold">Key</div>
                <span v-if="!noData">
                    <div>{{sound.key}}</div>
                </span>
                <span v-else>
                    loading <span><i class="fas fa-sync fa-spin"></i></span>
                </span>
            </div>

            <div class="notification rounded">
                <div class="has-text-weight-semibold">File Type</div>
                <span v-if="!noData">
                    <div>{{sound.file_mime}}</div>
                </span>
                <span v-else>
                    loading <span><i class="fas fa-sync fa-spin"></i></span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SoundDetailsBoxed',
    props: ['sound', 'isAdmin'],
    computed: {
        noData(){
            return Object.keys(this.sound).length === 0;
        },
    }
}
</script>

